import { Component, OnInit, Inject, EventEmitter, Output, Input } from "@angular/core";
import { DOCUMENT } from "@angular/common";
import { Menu, NavService } from "../../services/nav.service";
import { LayoutService } from "../../services/layout.service";
import SwiperCore, { Navigation, Pagination, Autoplay } from "swiper";
import { SendDataService } from "../../services/send-data.service";
import { NgxDatatableSSRConfig } from "../../model/ngx-datatable-ssr-config.model";
import { Subscription } from "rxjs";
import { StorageService } from "../../services/storage.service";
import { Router } from "@angular/router";
import { DataService } from "../../services/data.service";

SwiperCore.use([Navigation, Pagination, Autoplay]);
@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent implements OnInit {
  public elem: any;
  // headerTitle:any;
  formModel:any;
  public menuItems: Menu[];
  ngxDatatableSSRConfig = new NgxDatatableSSRConfig();
  subscription: Subscription;
  currentPath
  @Output() hideShowSidebar : EventEmitter<any> = new EventEmitter();
 @Input() showSidebar:boolean = false
  constructor(public layout: LayoutService, public navServices: NavService, @Inject(DOCUMENT) private document: any,
  private router: Router,
  public sendDataService:SendDataService,
  public storageService: StorageService,
  private dataService: DataService) {}

  ngOnInit() {
    this.elem = document.documentElement;
    this.subscription =  this.sendDataService.headerPageName.subscribe((res=>{
      if(res){
       // this.headerTitle = res?.headerTitle;
       this.currentPath = res?.path;
      }
    }))

  }
  onSearch(searchText){
     this.sendDataService.setPaginationData(searchText)
  }
  sidebarToggle() {
    this.navServices.collapseSidebar = !this.navServices.collapseSidebar;
    this.navServices.megaMenu = false;
    this.navServices.levelMenu = false;
  }

  layoutToggle() {
    if ((this.layout.config.settings.layout_version = "dark-only")) {
      document.body.classList.toggle("dark-only");
    }
    document.body.remove;
  }

  searchToggle() {
    this.navServices.search = true;
  }

  languageToggle() {
    this.navServices.language = !this.navServices.language;
  }

  toggleFullScreen() {
    this.navServices.fullScreen = !this.navServices.fullScreen;
    if (this.navServices.fullScreen) {
      if (this.elem.requestFullscreen) {
        this.elem.requestFullscreen();
      } else if (this.elem.mozRequestFullScreen) {
        /* Firefox */
        this.elem.mozRequestFullScreen();
      } else if (this.elem.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        this.elem.webkitRequestFullscreen();
      } else if (this.elem.msRequestFullscreen) {
        /* IE/Edge */
        this.elem.msRequestFullscreen();
      }
    } else {
      if (!this.document.exitFullscreen) {
        this.document.exitFullscreen();
      } else if (this.document.mozCancelFullScreen) {
        /* Firefox */
        this.document.mozCancelFullScreen();
      } else if (this.document.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        this.document.webkitExitFullscreen();
      } else if (this.document.msExitFullscreen) {
        /* IE/Edge */
        this.document.msExitFullscreen();
      }
    }
  }
  signOut(){
    this.dataService.showFullPageLoader();
    this.storageService.clear();
    setTimeout(() => {
      this.router.navigate(['/auth/login']).then(() => {
        this.dataService.hideFullPageLoader();
      });
    }, 400);
  }
  onClick(){
    this.showSidebar = !this.showSidebar
    this.hideShowSidebar.emit(this.showSidebar)
  }
  ngDestroy(){
    this.sendDataService.setPaginationData(undefined);
    this.subscription.unsubscribe();
  }
}
